import { render } from "./InformeEnvios.vue?vue&type=template&id=c4b2444e"
import script from "./InformeEnvios.vue?vue&type=script&lang=js"
export * from "./InformeEnvios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__